module.exports = __webpack_public_path__ + "static/img/btn.9dd16f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mengceng/btn.png
// module id = vqLV
// module chunks = 1